var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H12.75V3H2.25C1.425 3 0.75 3.675 0.75 4.5V12.75H2.25C2.25 13.995 3.255 15 4.5 15C5.745 15 6.75 13.995 6.75 12.75H11.25C11.25 13.995 12.255 15 13.5 15C14.745 15 15.75 13.995 15.75 12.75H17.25V9L15 6ZM4.5 13.875C3.8775 13.875 3.375 13.3725 3.375 12.75C3.375 12.1275 3.8775 11.625 4.5 11.625C5.1225 11.625 5.625 12.1275 5.625 12.75C5.625 13.3725 5.1225 13.875 4.5 13.875ZM14.625 7.125L16.095 9H12.75V7.125H14.625ZM13.5 13.875C12.8775 13.875 12.375 13.3725 12.375 12.75C12.375 12.1275 12.8775 11.625 13.5 11.625C14.1225 11.625 14.625 12.1275 14.625 12.75C14.625 13.3725 14.1225 13.875 13.5 13.875Z",
    fill: "#0080FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTruck);
export default __webpack_public_path__ + "static/media/ic_truck.738d222648d2259e730be95a7a6533ac.svg";
export { ForwardRef as ReactComponent };